article {
  padding: var(--size-2);
  display: flex;
  flex-direction: column;
  gap: var(--size-2);
  outline: var(--pos-border-solid);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-md);
  background-color: var(--pos-card-background);

  header {
    display: flex;
    flex-direction: column;
    gap: var(--size-2);
    h1 {
      margin: 0;
    }
  }
}
